import { Auth } from '@sdk/auth';
import axios, { AxiosError } from 'axios';
// import dotenv from 'dotenv';
// dotenv.config();

// Custom error class for API errors
export class APIError extends Error {
  constructor(message: string, public status?: number, public code?: string) {
    super(message);
    this.name = 'APIError';
  }
}

// Error handler function
const handleAxiosError = (error: AxiosError) => {
  if (error.response) {
    const status = error.response.status;
    const data = error.response.data as any;
    const backendMessage = data?.message;

    // Common error status codes with fallback messages
    const errorMessages = {
      401: 'Your session has expired. Please sign in again.',
      403: 'You are not authorized to perform this action.',
      404: 'The requested resource was not found.',
      422: 'Invalid data provided. Please check your input.',
      429: 'Too many requests. Please try again later.',
      500: 'An internal server error occurred. Please try again later.',
      502: 'Service temporarily unavailable. Please try again later.',
      503: 'Service temporarily unavailable. Please try again later.',
      504: 'Service temporarily unavailable. Please try again later.',
    };

    // Special case for "Forbidden resource" message
    const message =
      backendMessage === 'Forbidden resource'
        ? errorMessages[403]
        : backendMessage ||
          errorMessages[status as keyof typeof errorMessages] ||
          'An unexpected error occurred. Please try again.';
    const code = data?.code || status.toString();

    throw new APIError(message, status, code);
  }

  if (error.request) {
    throw new APIError(error.message, undefined, 'NETWORK_ERROR');
  }

  throw new APIError(error.message, undefined, 'REQUEST_ERROR');
};

export function createPublicAxios(baseUrl: string) {
  const baseConfig = {
    withCredentials: false,
    headers: {
      'Content-Type': 'application/json',
    },
  };
  const publicAxios = axios.create({
    ...baseConfig,
    baseURL: baseUrl,
  });
  publicAxios.interceptors.response.use(
    response => response,
    error => {
      return Promise.reject(handleAxiosError(error));
    },
  );
  return publicAxios;
}
export function createProtectedAxios(token: string, baseUrl: string) {
  const protectedAxios = createPublicAxios(baseUrl);
  protectedAxios.interceptors.request.use(async config => {
    if (!token) {
      throw new Error('Not authenticated. Please authenticate first.');
    }
    config.headers.Authorization = `Bearer ${token}`;
    return config;
  });
  return protectedAxios;
}
